<script setup lang="tsx">
import RoutePath from './route-path';
import RouteName from './route-name';

interface RoutePathProps {
  path: string,
  name?: never,
  params?: never,
}

interface RouteNameProps {
  name: string,
  params?: Record<string, boolean | number | string>,
  path?: never,
}

const props = defineProps<RouteNameProps | RoutePathProps>();

</script>

<template>
  <RoutePath v-if="props.path" :path="props.path"><slot></slot></RoutePath>
  <RouteName v-else-if="props.name" :name="props.name" :params="props.params"><slot></slot></RouteName>
</template>